<template>
    <div>

    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    created() {
        let path=this.$getUrlKey("path");
        this.$getHTYSQyWechatLogin(path);
    }
}
</script>


// WEBPACK FOOTER //
// src/page/login/htyslogin.vue